import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { SelectItem } from 'primeng/api';
import { PhysicianAccountPgpsDTO } from '@mynexus/mynexus-ui-lib';

@Component({
    selector: 'app-physician-select',
    templateUrl: './physician-select.component.html',
    styleUrls: ['./physician-select.component.scss'],
    standalone: false
})
export class PhysicianSelectComponent {
  @Input() label = '';
  @Input() set searchResultList(value: PhysicianAccountPgpsDTO[]) {
    this.searchList = value;
    this.buildPhysicianSelectItemList();
  }

  get searchResultList(): PhysicianAccountPgpsDTO[] {
    return this.searchList;
  }

  @Output() selectedPhysician = new EventEmitter<PhysicianAccountPgpsDTO>();

  physicianSelectionForm: FormGroup = new FormGroup({
    selectedPhysician: new FormControl([])
  });
  availablePhysicians: SelectItem[] = [];

  private searchList: PhysicianAccountPgpsDTO[] = [];

  buildPhysicianSelectItemList() {
    this.availablePhysicians = [];

    if (this.searchResultList && this.searchResultList.length > 0) {
      this.searchResultList.forEach((physician, index) => {
        const { physicianAccountDTO } = physician;
        const displayphone = physicianAccountDTO.phone ? 'phone #: ' + physicianAccountDTO.phone : '';

        this.availablePhysicians
          .push({
            value: index,
            label:
              `${physicianAccountDTO.accountName},
               ${physicianAccountDTO.physicalStreet},
               ${physicianAccountDTO.physicalCity},
               ${physicianAccountDTO.physicalState}
               ${physicianAccountDTO.physicalZip},
               ${displayphone}`
          });
      });
    }
  }

  physicianListBoxClick($event: any) {
    const val = $event.option.value;

    this.selectedPhysician.emit(this.searchResultList[val]);
  }
}
